import React, { useEffect, useState } from 'react';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import courseback from "../../../assets/course-back.jpg";
import { useParams } from 'react-router-dom';
import { GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { App, Button, Card, Col, Form, Input, Modal, Row, Tabs } from 'antd';
import './commonCourse.css';
import EligibilityCheckForm from '../eligibilitycheckForm';
import course1 from "../../../assets/course1.webp";
import course2 from "../../../assets/eligibility_check.webp";
import course3 from "../../../assets/course1.webp";
import course4 from "../../../assets/course3.webp";
import png1 from "../../../assets/png1.png";
import png2 from "../../../assets/png2.png";
import png3 from "../../../assets/png3.png";
import png4 from "../../../assets/png6.png";
import png5 from "../../../assets/png4.png";
import png6 from "../../../assets/png5.png";

import Hyderabad from '../../../assets/Hyderabad.png';
import Bangalore from '../../../assets/Bangalore.png';
import Delhi from '../../../assets/Delhi.png';
import EnrollModal from '../../booking-payment/enrollmentModel';
import why1 from '../../../assets/why1.webp';
import FormItem from 'antd/es/form/FormItem';

import CourseDisplayCard from './courseDisplayCard';
function Ea() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('eligibility');
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const tabItems = [
        {
            key: 'eligibility',
            label: <div className="tab-label">Eligibility Check</div>,
            children: (
                <div className="tab-content eligibility-tab">
                    <div className="tab-text">
                        <h2>Eligibility Check</h2>
                        <ul>
                            <li>Candidates should be at least 18 years old</li>
                            <li>Candidates must obtain a PTIN to sit for SEE Exams
                            </li>
                        </ul>
                        <h2>Certificate Eligibility:</h2>
                        <ul>
                            <li>Passing all 3 papers of the SEE Exam is required</li>
                            <li>Completing Form 23 for the licensing application is required

                            </li>
                        </ul>
                        <div style={{ marginTop: "20px" }}>
                            <Button type="primary" onClick={() => setIsEligibilityModalOpen(true)}>
                                Check Your Eligibility
                            </Button>
                        </div>
                    </div>
                    <div className="tab-image">
                        <img src={course2} alt="Course Visual" />
                    </div>
                </div>

            ),
        },
        {
            key: 'exam',
            label: <div className="tab-label">Pattern and Scoring</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                3 Part exam with 100 MCQs each      </li>
                            <li>Pass Marks: 105 from a total of 130 marks</li>
                            <li>Exam Dates: May 5th May 23rd, 2025</li>

                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="Course Visual" />
                    </div>
                </div>

            ),
        },

        {
            key: 'outcomes',
            label: <div className="tab-label">Career Opportunities</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                Tax Advisor  </li>
                            <li>Tax Consultant</li>
                            <li>Tax Auditor</li>
                            <li>Tax Guide</li>

                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="Course Visual" />
                    </div>
                </div>

            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">EA Exam Cost</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                PTIN registration or renewal - 19.75$ (2024)
                            </li>
                            <li>Examination - 268$ Per Part
                            </li>
                            <li>Enrollment to practice before IRS application – 140$
                            </li>

                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt="Course Visual" />
                    </div>
                </div>
            ),
        },


    ];
    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);
                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
        }
    }, [id]);
    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };

    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };
    const downloadBrochure = () => {
        window.open(courseDetails?.course_Brousher, '_blank');
    };
    const whyTexts = [
        "EA & CPA Qualified Faculties",
        "Official Partner of Hock International USA",
        "Hock Premium Study Materials",
        "Strong Placement History in Big 4’s",
        "100% Placement Assistance",
        "Premium Online&Offline Batches-(English & Malayalam)",
        "Big 4 Alumni as Mentors",
    ];
    return (
        <div>
            <Header />
            <div className="course-page-container">
                <div className="course-hero">
                    <img src={courseback} alt="Course Hero" className="course-hero-image" />
                    <div className="course-hero-overlay"></div>

                    <div className="course-hero-inner">
                        {/* Left Content */}
                        <div className="course-hero-content left-content">
                            <h1>{isLoading ? "Loading..." : courseDetails?.course_title || "Course Title"}</h1>
                            <i>(Authorized US Tax Practitioner)</i>
                            <p>{courseDetails?.course_duration}</p>
                            <p>
                                Earn upto 10+LPA in just 6 months! <br />
                                Jobs at Big 4 & MNCs in India.
                            </p>

                            <Button
                                className="courseCard-button primary-button"
                                type="primary"
                                onClick={(e) => showModal(id!, e)}
                            >
                                Enroll Now
                            </Button>

                            {isModalVisible && (
                                <EnrollModal
                                    visible={isModalVisible}
                                    onClose={handleCloseModal}
                                    courseId={selectedCourseForEnroll}
                                />
                            )}
                        </div>

                        {/* Right Form */}
                        <div className="course-hero-content right-form">
                            <h2>  Make an Enquiry</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={submitHandler}
                                initialValues={{
                                    name: '',
                                    phone: '',
                                    email: '',
                                    message: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please enter your name' }]}
                                        >
                                            <Input placeholder="Your Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone"
                                            name="phone"
                                            rules={[{ required: true, message: 'Please enter your phone' }]}
                                        >
                                            <Input placeholder="Your phone" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{ required: true, message: 'Please enter your email' }]}
                                        >
                                            <Input type="email" placeholder="Email Address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter your message' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>

                <div className="course-details">
                    <div className="description-card">

                        <ul>
                            {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                            ))}
                        </ul>
                        <div style={{ display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap', justifyContent: "center" }}>
                            <Button type="primary" onClick={downloadBrochure}>
                                Download Brochure
                            </Button>

                        </div>
                    </div>
                    <div>
                        <br />
                        <h2 className="homepage-heading">About EA</h2>


                        <div className="course-details-tabs-container">
                            <div className="course-details-tabs">
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    type="card"
                                    className="custom-tabs"
                                    items={tabItems}
                                    centered
                                />
                            </div>
                        </div>


                        <Modal
                            title="Check Eligibility"
                            open={isEligibilityModalOpen}
                            onCancel={() => setIsEligibilityModalOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <EligibilityCheckForm
                                courseId={id ? Number(id) : 0}
                                onClose={() => setIsEligibilityModalOpen(false)}
                            />
                        </Modal>
                    </div>
                    <div>
                        <div className="why-us-section">
                            <div className="why-us-title-box">
                                <h2 className="homepage-heading">Why EA</h2>
                            </div>
                            <div className="why-us-card-grid">
                                {[png1, png2, png3, png4, png5, png6].map((img, index) => (
                                    <div className="why-us-card" key={index}>
                                        <div className="ea-card">
                                            <div className="why-us-image">
                                                <img src={img} alt={`Why ${index + 1}`} />
                                            </div>
                                            <div className="why-us-text">
                                                <h3>
                                                    {
                                                        [
                                                            "Global Qualification",
                                                            "High Salary",
                                                            "Work in Big 4",
                                                            "Federal Tax Designation",
                                                            "Representation Authority before IRS",
                                                            "Course duration 5-6 months only"
                                                        ][index]
                                                    }
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <h2 className="homepage-heading">Why Meantoir? </h2>
                            <ul className="home-why-list">
                                {whyTexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="home-why-right">
                            <img src={why1} alt="Why Choose Us" className="home-why-image" />
                        </div>
                    </div>
                </div>
                <div className="ea-section-container">
                    {/* Left Side - Exam Details */}
                    <div className="ea-exam-details">
                        <div className="ea-title-box">
                            <h2 className="ea-title">EA Exam Parts</h2>
                        </div>

                        <h2 className="ea-total-exams">Total Exams = 3</h2>

                        <Card className="ea-exam-card">
                            <p>Part 1 - Individual Taxation</p>
                            <p>Part 2 - Business</p>
                            <p>Part 3 - Representation before IRS</p>
                        </Card>
                    </div>

                    {/* Right Side - Cities */}
                    <div className="ea-locations">
                        <div className="ea-title-box">
                            <h2 className="ea-title">EA Prometric Locations/Centers in India</h2>
                        </div>

                        <div className="ea-card-grid">
                            {[Bangalore, Hyderabad, Delhi].map((img, index) => (
                                <div className="ea-card" key={index}>
                                    <div className="ea-card-content">
                                        <div className="ea-image">
                                            <img src={img} alt={`City ${index + 1}`} />
                                        </div>
                                        <div className="ea-text">
                                            <h3>{["Bangalore", "Hyderabad", "Delhi"][index]}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>



                    <div style={{ textAlign: "center" }}>
                        <h2 style={{ width: "100%", textAlign: "center", fontSize: "2.5rem", }}>Frequently Asked Questions(FAQ's)</h2>
                        <p style={{ width: "100%", textAlign: "center", fontSize: "1.5rem", }}>
                            Below we have assembled answers to the most common questions that we receive about what it means to be an Enrolled Agent (EA) and how to become an EA.
                        </p>
                    </div>
                    <div >
                        <div>
                            <h3 onClick={() => toggleSection("whatIsEA")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is an EA?
                            </h3>
                            {openSection === "whatIsEA" && (
                                <p style={{ width: "100%", fontSize: "1.5rem", }}>
                                    An Enrolled Agent (EA) is a tax professional authorized by the United States federal government to represent
                                    taxpayers before the Internal Revenue Service (IRS). EAs specialize exclusively in taxation and have a
                                    unique expertise in tax law, which allows them to provide tax-related services to individuals and businesses.
                                    EAs are authorized to represent taxpayers in all matters before the IRS including audits, collections, and
                                    appeals.
                                </p>
                            )}
                        </div>

                        <div>
                            <h3 onClick={() => toggleSection("whoIsItFor")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Who is it for?
                            </h3>
                            {openSection === "whoIsItFor" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The EA credential is ideal for individuals with a strong interest in tax law and who want to develop a
                                        career in IRS representation, tax consulting, tax return preparation, as well as other tax-related services.
                                    </p>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Enrolled Agents are a valuable resource for anyone in need of tax-related assistance. Becoming an Enrolled
                                        Agent demonstrates a high level of knowledge in tax law and can lead to increased credibility, career
                                        opportunities, and the ability to offer a wider range of tax-related services.
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Howmuch")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                How much does it cost to become an EA?
                            </h3>
                            {openSection === "Howmuch" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The total cost to become an EA includes both
                                        <ul>
                                            <li>Exam registration fees </li>
                                            <li>
                                                Exam prep materials.
                                            </li>
                                        </ul>
                                    </p>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The costs to become an EA include:
                                        <ul>
                                            <li>
                                                $19.75 PTIN Fee - You need to Apply for a PTIN if you do not already have one
                                            </li>
                                            <li>
                                                $267 Exam Fee for Part 1</li>
                                            <li>
                                                $267 Exam Fee for Part 2
                                            </li>
                                            <li>$267 Exam Fee for Part 3</li>
                                            <li>$140 Enrollment Fee (paid after passing all of the exams)</li>
                                            <li>Example: If you do not already have a PTIN and pass all 3 exams on your first attempt, the total cost is $960.75. Re-takes will increase the total cost.</li>
                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Whataretheeligibility")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What are the eligibility requirements?
                            </h3>
                            {openSection === "Whataretheeligibility" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        One unique aspect of becoming an EA is that there are no specific education or experience requirements to begin, making the path to becoming an EA accessible and open to anyone. However, it's important to note that while there are no strict requirements to sit for the exam, the process of becoming an EA still requires hard work, study, and dedication.
                                    </p>
                                    <b style={{ fontSize: "1.5rem", }}>
                                        Note: You have to pass all three parts of the exam within two years after passing your first Part.
                                    </b>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("WhatistestedontheEAexam")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is tested on the EA exam?
                            </h3>
                            {openSection === "WhatistestedontheEAexam" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The three EA exams are based on current tax law. The exam testing cycle runs from May 1 through the end of February of the following year. There is no testing in March and April. Each part of the EA exam covers specific Domains (Sections) that are released by the IRS in Exam Content Outlines.
                                    </p>
                                    <p style={{ fontSize: "1.5rem", }}>EA Part 1</p>
                                    <ul>
                                        <li>Preliminary Work and Taxpayer Data</li>
                                        <li>Income and Assets</li>
                                        <li>Deductions and Credits</li>
                                        <li>Taxation</li>
                                        <li>Advising the Individual Taxpayer</li>
                                        <li>Specialized Returns for Individuals</li>
                                    </ul>
                                    <p style={{ fontSize: "1.5rem", }}>EA Part 2</p>
                                    <ul>
                                        <li>Business Entities and Considerations</li>
                                        <li>Business Tax Preparation</li>
                                        <li>Specialized Returns and Taxpayers</li>

                                    </ul>
                                    <p style={{ fontSize: "1.5rem", }}>EA Part 3</p>
                                    <ul>
                                        <li>Practices and Procedures</li>
                                        <li>Representation before the IRS</li>
                                        <li>Specific Areas of Representation</li>
                                        <li>Filing Process</li>

                                    </ul>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Whatistheformatand")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is the format and duration of the exam?
                            </h3>
                            {openSection === "Whatistheformatand" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Each Part of the EA exam contains 100 multiple-choice questions to be answered in 3.5 hours.
                                    </p>

                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("WheredoItaketheEAexam")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Where do I take the EA exam and how do I register?
                            </h3>
                            {openSection === "WheredoItaketheEAexam" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Exam are taken in-person at Prometric Testing Centers located in major cities across the US and select cities in international locations.
                                    </p>

                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Howistheexamgraded?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                How is the exam graded?
                            </h3>
                            {openSection === "Howistheexamgraded?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Based on the difficulty of the questions randomly selected for your exam and the number of questions that you got correct you are given a “scaled score” between 40 and 130. A 105 score is required to pass the exam.                                    </p>
                                    <b style={{ fontSize: "1.5rem", }}>
                                        Note: 105 does NOT translate to 72%. It is simply a score and not a percentage of anything.
                                    </b>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Arethereanycontinuingeducationrequirements?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Are there any continuing education requirements?                            </h3>
                            {openSection === "Arethereanycontinuingeducationrequirements?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Once you become an EA, you are required to:</p>
                                    <ul>
                                        <li>
                                            Renew your status every three years.
                                        </li>
                                        <li>Renew your PTIN (Preparer Tax Identification Number) between mid - October - December 31 of each year</li>
                                        <li>Meet Continuing Education Requirements, which include 72 hours every three years (minimum of 16 hours per year, two of which must be on ethics).</li>
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <h2 className="homepage-heading">Explore More Courses</h2>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>

                    <CourseDisplayCard />
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default Ea;
